import { render, staticRenderFns } from "./detail_item.vue?vue&type=template&id=135465e4&scoped=true"
import script from "./detail_item.vue?vue&type=script&lang=js"
export * from "./detail_item.vue?vue&type=script&lang=js"
import style0 from "./detail_item.vue?vue&type=style&index=0&id=135465e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135465e4",
  null
  
)

export default component.exports